const feedback = {
  feedback: {
    buttonLabel: 'تقييم',
    title: 'شاركنا تجربتك',
    subtitle: 'ساعدنا في تحسين تجربتك',
    questions: {
      overall: 'كيف تقيّم تجربتك العامة؟',
      easeOfUse: 'ما مدى سهولة التنقل في الموقع؟',
      design: 'كيف تقيّم تصميم الموقع؟',
      recommend: 'هل توصي الآخرين بهذا الموقع؟',
      improvements: 'ما الذي تود أن نحسّنه؟',
      additional: 'هل لديك تعليقات أو اقتراحات أخرى؟',
    },
    placeholders: {
      improvements: 'شاركنا اقتراحاتك للتحسين...',
      additional: 'لا تتردد في مشاركة أي أفكار أخرى...',
    },
    options: {
      yes: 'نعم',
      no: 'لا',
    },
    validation: {
      ratingRequired: 'يرجى تقديم التقييم العام على الأقل.',
    },
    submit: 'إرسال التقييم',
    submitting: 'جاري الإرسال...',
    success: {
      title: 'شكراً لك!',
      message: 'تم إرسال تقييمك بنجاح. نقدّر مشاركتك!',
    },
    error: 'تعذر إرسال التقييم. يرجى المحاولة مرة أخرى.',
    privacy: 'تقييمك يساعدنا على التحسين. نحترم خصوصيتك.',
  },
};

export default feedback;
